import './index.scss';

import * as detectIt from 'detect-it';
import MobileDetect from 'mobile-detect';
import Flickity from 'flickity';
import * as d3 from "d3";
import easyScroll from 'easy-scroll';
import mime from 'mime-types';
import cloneDeep from 'clone-deep';


import * as THREE from '../node_modules/three/build/three.module.js';
import {
    DDSLoader
} from '../node_modules/three/examples/jsm/loaders/DDSLoader.js';
import {
    MTLLoader
} from '../node_modules/three/examples/jsm/loaders/MTLLoader.js';
import {
    OBJLoader
} from '../node_modules/three/examples/jsm/loaders/OBJLoader.js';
import {
    OrbitControls
} from '../node_modules/three/examples/jsm/controls/OrbitControls.js';


let vw,
    vh,
    rem,
    dmx = 0;

let istouch = false,
    ismobile = false,
    movetitles = false;

let map,
    tree,
    width,
    radius,
    svg,
    svgwrap,
    svgratio,
    svgvw,
    svgr = 0,
    svgframe,
    svgfps,
    svgtime,
    gr,
    dots,
    remdots,
    touchdots,
    rootdots,
    touchtitles,
    canvastype = {},
    roottitles = [];

let objectwrap,
    object,
    objcontainer,
    camera,
    scene,
    controls,
    renderer,
    objvw,
    objvh,
    objhalfX,
    objhalfY,
    objzoom;

let mouseX = 0,
    mouseY = 0;

let ht;

let timeinterval,
    searchinterval,
    tabtimeout = 0;

let yearlist = [];


init();

function init() {

    gettouch();
    getmobile();

    resize();
    //    showtime();

    if (typeof umap !== 'undefined') {

        buildtree();

    }

    getmedia();
    getobjects();
    buildyears();

    window.addEventListener('resize', resize, false);

}


function gettouch() {

    if (detectIt.primaryInput === 'touch') {

        touchtitles = [];
        touchdots = [];
        movetitles = true;
        istouch = true;

    }

}

function getmobile() {

    let md = new MobileDetect(window.navigator.userAgent);
    if (md.mobile()) {

        ismobile = true;


    }

}

function resize() {

    vw = window.innerWidth;
    vh = window.innerHeight;

    let fsize = parseInt(window.getComputedStyle(document.body).fontSize);
    rem = fsize / vw * 100;

    if (ismobile) {
        
        let landing = document.getElementById('landing-wrap');

        if (landing) {

            landing.style.maxHeight = vh + "px";

        }

    }

    let dendrowrap = document.getElementById('dendrogram-wrap');
    let linkswrap = document.getElementById('dendrogram-links-wrap');

    if (dendrowrap || linkswrap) {

        let wrap;

        if (dendrowrap) {

            wrap = dendrowrap;

        } else {

            wrap = linkswrap;
            svgr = 0;

        }

        svgvw = 1;

        let dsize = wrap.getBoundingClientRect();

        svgratio = dsize.width / dsize.height;

        if (svgratio < 1) {

            svgvw = dsize.height / dsize.width;

        }


        remdots = fsize / dsize.height / 2 * 80;

        if ((canvastype.related && !istouch) || canvastype.landing) {

            resizeellipse();

        }

        let dendrocenter = document.getElementById('dendrocenter');

        if (dendrocenter.classList.contains('relocated')) {

            updatecenter(false);

        }

    }

}

function landingui() {

    //    DENDROGRAM CENTER
    let menuinfo = document.getElementById('menu-information');

    if (typeof menuinfo != 'undefined') {

        menuinfo.addEventListener('click', function () {

            let duration = 1100;

            let scrollh = window.scrollY;

            easyScroll({
                'scrollableDomEle': window,
                'direction': 'bottom',
                'duration': duration,
                'easingPreset': 'easeInOutQuad',
                'scrollAmount': vh - scrollh
            });

        });

    }

    //    MENU TABS

    let menurows = document.querySelectorAll('.menu-row');

    for (let r = 0; r < menurows.length; r++) {

        preparemenu(menurows[r]);

    }

    //    SEARCH TAB

    let searchdiv = document.getElementById('input-search');

    if (searchdiv) {

        searchdiv.addEventListener('input', startsearch);

    }

    //    LANDING INFO SCROLL

    let landingbottom = document.getElementById('landing-bottom');

    if (landingbottom) {

        document.addEventListener('scroll', landingscroll);

    }


}

function landingscroll() {

    let sh = window.scrollY;
    let st = 0.5;

    if (sh > st * vh && !document.body.classList.contains("landing-scroll-trigger")) {

        document.body.classList.add('landing-scroll-trigger');

        let landingwrap = document.getElementById('landing-wrap');
        landingwrap.addEventListener('click', landingreturn);


    } else if (sh < st * vh && document.body.classList.contains("landing-scroll-trigger")) {

        document.body.classList.remove('landing-scroll-trigger');

        let landingwrap = document.getElementById('landing-wrap');
        landingwrap.removeEventListener('click', landingreturn, false);

    }

}

function landingreturn() {

    let duration = 1100;

    let scrollh = window.scrollY;

    easyScroll({
        'scrollableDomEle': window,
        'direction': 'top',
        'duration': duration,
        'easingPreset': 'easeInOutQuad',
        'scrollAmount': scrollh
    });

}

function preparemenu(row) {

    let tab = row.querySelector('.menu-tab');

    if (tab) {

        row.addEventListener('click', opentab);
        row.tab = tab;

    }

}

function opentab(evt) {

    let row = evt.currentTarget;
    let tab = row.tab;

    setTimeout(function () {

        //        ADD MOBILE CLASS

        document.body.classList.add('touch-tab');

        let tcontent = tab.querySelector('.menu-tab-content');

        let th = tcontent.offsetHeight;
        tab.style.height = th + "px";

        row.removeEventListener('click', opentab, false);
        row.classList.remove('tab-idle');

        setTimeout(function () {

            let wrap = document.getElementById('landing-wrap');
            wrap.addEventListener('click', closetab);
            wrap.activerow = row;
            wrap.activetab = tab;

            //            DISABLE EVENT FOR OPEN TAB

            tab.addEventListener('click', function (evt) {

                evt.stopImmediatePropagation();

            })


        }, 100);

        //    FOCUS SEARCH

        let search = tcontent.querySelector('#input-search');

        if (search) {

            search.value = "";
            search.focus();

        }

        //    FILTER FUNCTIONS

        if (row.id === "menu-filter") {

            let tab = document.getElementById('menu-filter');

            let entries = tab.querySelectorAll('.menu-filter-trigger');

            for (let i = 0; i < entries.length; i++) {

                entries[i].addEventListener('click', togglefilter);
                entries[i].el = entries[i];
                entries[i].tab = tab;

            }

        }

        tabtimeout = 270;

    }, tabtimeout);

}

function closetab(evt) {

    if (!evt.srcElement.classList.contains('menu-filter-entry')) {

        let wrap = evt.currentTarget;
        let row = wrap.activerow;
        let tab = wrap.activetab;

        tab.style.height = "0px";

        wrap.removeEventListener('click', closetab, false);
        row.addEventListener('click', opentab);

        row.classList.add('tab-idle');

        clearTimeout(searchinterval);

        if (!document.body.classList.contains("filter")) {

            hidesearch();

        }

        tabtimeout = 0;

        setTimeout(function () {

            //        REMOVE MOBILE CLASS

            document.body.classList.remove('touch-tab');

        }, 260)

    }

}

function buildyears() {

    let tab = document.getElementById('menu-filter');

    if (tab) {

        let yeargroup = tab.querySelector('.menu-group-year');

        if (yeargroup) {

            for (let i = 0; i < yearlist.length; i++) {

                let el = document.createElement('div');

                el.classList.add('menu-filter-entry');
                el.classList.add('menu-filter-trigger');
                el.classList.add('menu-filter-option');

                el.setAttribute("filter-type", "year");
                el.setAttribute("filter", yearlist[i]);

                el.innerHTML = yearlist[i];

                yeargroup.appendChild(el);

            }

        }

    }

}

//SEARCH FUNCTIONS

function startsearch() {

    clearTimeout(searchinterval);
    searchinterval = setTimeout(function () {

        let searchdiv = document.getElementById('input-search');
        let query = searchdiv.value;
        let queryurl = query.split(' ').join('+');

        getJSON(window.location + '/search?q=' + queryurl).then(data => {

            if (document.body.classList.contains("filter")) {

                resetfilter();

            }

            hidesearch();
            showsearch(data);

        })

    }, 500)

}

function hidesearch() {

    let dendrowrap = document.getElementById('dendrogram-wrap');

    document.body.classList.add('search-transition');

    setTimeout(function () {

        document.body.classList.remove('search-transition');

    }, 400);

    document.body.classList.remove('search');
    document.body.classList.remove('filter');

    let fd = dendrowrap.querySelectorAll('circle.found');

    for (let d = 0; d < fd.length; d++) {

        fd[d].classList.remove('found');

    }

}

function showsearch(results) {

    let dendrowrap = document.getElementById('dendrogram-wrap');

    document.body.classList.add('search');

    for (let r = 0; r < results.length; r++) {

        let dot = dendrowrap.querySelector('circle[id="' + results[r] + '"]');

        if (dot) {

            let type = dot.getAttribute('type');

            dot.classList.add('found');

        }

    }

}

//FILTER FUNCTIONS

function togglefilter(evt) {

    //    TOGGLE RADIO

    let el = evt.currentTarget.el;
    let tab = evt.currentTarget.tab;
    let filter = el.getAttribute('filter-type');

    let options = tab.querySelectorAll('[filter-type="' + filter + '"]');

    for (let o = 0; o < options.length; o++) {

        options[o].classList.remove('menu-filter-active');

    }

    el.classList.add('menu-filter-active');
    tab.classList.add('tab-filter-active');

    initfilter();

}

function initfilter() {

    let tab = document.getElementById('menu-filter');

    //    GET FILTER

    let proceed = false;

    let ft = {};
    ft.criteria = 0;

    //    PAGE TYPE FILTER

    ft.page = {};
    ft.page.active = false;

    let pagequery = tab.querySelector('.menu-filter-option.menu-filter-active[filter-type="type"]');

    if (pagequery) {

        ft.page.active = true;
        ft.page.filter = pagequery.getAttribute('filter');
        ft.criteria++;

        proceed = true;

    }

    //    MEDIA FILTER

    ft.media = {};
    ft.media.active = false;

    let mediaquery = tab.querySelector('.menu-filter-option.menu-filter-active[filter-type="media"]');

    if (mediaquery) {

        ft.media.active = true;
        ft.media.filter = mediaquery.getAttribute('filter');
        ft.criteria++;

        proceed = true;

    }

    //    YEAR FILTER

    ft.year = {};
    ft.year.active = false;

    let yearquery = tab.querySelector('.menu-filter-option.menu-filter-active[filter-type="year"]');

    if (yearquery) {

        ft.year.active = true;
        ft.year.filter = parseInt(yearquery.getAttribute('filter'));
        ft.criteria++;

        proceed = true;

    }

    //    RECENT FILTER

    ft.recent = {};
    ft.recent.active = false;

    let recentquery = tab.querySelector('.menu-filter-option.menu-filter-active[filter-type="date"]');

    if (recentquery) {

        ft.recent.active = true;
        ft.recent.filter = recentquery.getAttribute('filter');

        proceed = true;

    }

    //    BUILD CASE FOR  SINGULAR DATE FILTER

    ft.collect = false;

    if (!ft.media.active && !ft.page.active && !ft.year.active && ft.recent.active) {

        ft.collect = true;

    }

    //    BUILD FILTER

    if (proceed) {

        buildfilter(ft);

    } else {

        hidesearch();
        tab.classList.remove('tab-filter-active');

    }


}

function resetfilter() {

    let tab = document.getElementById('menu-filter');
    tab.classList.remove('tab-filter-active');

    let filterquery = tab.querySelectorAll('.menu-filter-option');

    for (let f = 0; f < filterquery.length; f++) {

        filterquery[f].classList.remove('menu-filter-active');

    }


    let allquery = tab.querySelectorAll('.menu-filter-all');

    for (let f = 0; f < allquery.length; f++) {

        allquery[f].classList.add('menu-filter-active');

    }

}

function buildfilter(ft) {

    let mapc = cloneDeep(map);
    mapc = mapc.children.slice(0);

    //    RUN FILTER

    let mapfilter = filterquery(mapc, ft);

    if (mapfilter.length) {

        //        FILTER BY DATE

        if (ft.recent.active) {

            let sorted = mapfilter.sort(function (a, b) {
                return b.modified - a.modified;
            });

            mapfilter = sorted.slice(0, ft.recent.filter);

        }

        //        GET IDS

        let ids = [];

        for (let i = 0; i < mapfilter.length; i++) {

            ids[i] = mapfilter[i].id;

        }

        //        SHOW FILTER

        hidesearch();
        document.body.classList.add('filter');
        showsearch(ids);

    } else {

        let ids = [];

        hidesearch();
        document.body.classList.add('filter');
        showsearch(ids);

    }

}

function filterquery(arr, q) {

    let matches = [];

    arr.filter(function f(o) {

        //        COLLECT ALL IF ONLY RECENT FILTER

        if (q.collect) {

            matches.push(o);

        } else {

            //            COLLECT FILTER

            let match = false;
            let criteria = 0;

            //        FIND FILES

            if (q.media.active) {

                let matchedfile = false;

                for (let f = 0; f < o.files.length; f++) {

                    let filemime = mime.lookup(o.files[f]);
                    let type = filemime.split('/')[0];

                    if (type === q.media.filter) {

                        matchedfile = true;

                    }

                }

                if (matchedfile) {

                    criteria++;
                    match = true;

                }

            }

            //        FIND TYPE

            if (q.page.active) {

                if (o.type === q.page.filter) {

                    criteria++;
                    match = true;

                }

            }

            //        FIND YEAR

            if (q.year.active) {

                let foundyear = false;

                if (o.yearlist) {

                    if (o.yearlist.includes(q.year.filter)) {

                        foundyear = true;

                    }

                }

                let oyear = new Date(o.modified * 1000).getFullYear();

                if (oyear === q.year.filter) {

                    foundyear = true;

                }

                if (foundyear) {

                    criteria++;
                    match = true;

                }

            }

            if (match && criteria >= q.criteria) {

                matches.push(o);

            }

        }

        if (o.children) {
            return (o.children = o.children.filter(f)).length
        }
    })

    return matches;

}



function getJSON(path) {
    return fetch(path).then(response => response.json());
}

function occurrences(string, subString, allowOverlapping) {

    string += "";
    subString += "";
    if (subString.length <= 0) return (string.length + 1);

    var n = 0,
        pos = 0,
        step = allowOverlapping ? 1 : subString.length;

    while (true) {
        pos = string.indexOf(subString, pos);
        if (pos >= 0) {
            ++n;
            pos += step;
        } else break;
    }
    return n;
}

function gettime(t) {


    let options = {
            timeZone: 'Europe/Berlin',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
        },
        formatter = new Intl.DateTimeFormat([], options);

    return formatter.format(localtime);


}

function currentyear() {

    if (localtime) {

        let options = {
                timeZone: 'Europe/Berlin',
                year: 'numeric'
            },
            formatter = new Intl.DateTimeFormat([], options);

        return parseInt(formatter.format(localtime));

    }

}

function showtime() {

    let time = document.getElementById('time');

    if (time) {

        let utime = gettime();
        let otime = utime.split(":");

        let hour = document.createElement('span');
        hour.innerHTML = otime[0];
        time.appendChild(hour);

        let doth = document.createElement('span');
        doth.innerHTML = ":";
        time.appendChild(doth);

        let minute = document.createElement('span');
        minute.innerHTML = otime[1];
        time.appendChild(minute);

        let dotm = document.createElement('span');
        dotm.innerHTML = ":";
        time.appendChild(dotm);

        let second = document.createElement('span');
        second.innerHTML = otime[2];
        time.appendChild(second);

        //        doth.classList.add('timedot');
        //        dotm.classList.add('timedot');

        timeinterval = setInterval(function () {

            localtime.setSeconds(localtime.getSeconds() + 1);

            let utime = gettime();
            let otime = utime.split(":");

            hour.innerHTML = otime[0];
            minute.innerHTML = otime[1];
            second.innerHTML = otime[2];

        }, 1000)


    }

}


function count(string, subString, allowOverlapping) {

    string += "";
    subString += "";
    if (subString.length <= 0) return (string.length + 1);

    var n = 0,
        pos = 0,
        step = allowOverlapping ? 1 : subString.length;

    while (true) {
        pos = string.indexOf(subString, pos);
        if (pos >= 0) {
            ++n;
            pos += step;
        } else break;
    }
    return n;
}


function buildtree() {

    //    STRUCTURE MAP WITH CHILDREN

    let mapentries = Object.entries(umap);
    let dim = [];
    let a = [];
    let t = 0;
    let c = 0;

    for (const [title, entry] of mapentries) {

        let id = String(entry.id);
        let b = count(id, "/");

        entry.children = [];
        entry.title = entry.content.title;

        if (typeof dim[b] == "undefined") {
            dim[b] = [];
        }
        dim[b].push(entry);

    }

    for (let d = dim.length - 1; d > 0; d--) {

        for (let l = 0; l < dim[d].length; l++) {

            //            SET TYPE OF ENTRY BY CONTENT SIZE

            let csize = Object.keys(dim[d][l].content).length;

            if (csize > 2) {

                dim[d][l].type = "article";

            } else {

                dim[d][l].type = "category";

            }

            //            SET COLOR

            let parentid = String(dim[d][l].parent);
            let pcolor = parentid.split("/");

            if (pcolor[0] === "how") {

                dim[d][l].color = "red";

            } else if (pcolor[0] === "what") {

                dim[d][l].color = "green";

            } else if (pcolor[0] === "who") {

                dim[d][l].color = "blue";

            }

            //            GET YEAR

            if (dim[d][l].content.year &&
                typeof localtime !== 'undefined') {

                let yc = currentyear();
                dim[d][l].yearlist = filteryear(dim[d][l].content.year, yc);

            }


            //            PUSH ENTRY

            let parent = dim[d - 1].find(element => element.id === parentid);
            parent.children.push(dim[d][l]);

        }

    }

    //    PREPARE MAP

    map = {};
    map.name = "Bio Design Lab";
    map.type = "category";
    map.id = "biodesignlab";
    map.children = [];

    for (let d = 0; d < dim[0].length; d++) {

        if (dim[0][d].title && dim[0][d].children.length && dim[0][d].id != "news") {

            dim[0][d].root = true;
            dim[0][d].type = 'category';
            map.children[d] = dim[0][d];

            if (dim[0][d].id === "how") {

                dim[0][d].color = "red";

            } else if (dim[0][d].id === "what") {

                dim[0][d].color = "green";

            } else if (dim[0][d].id === "who") {

                dim[0][d].color = "blue";

            }

        }

    }

    canvasquery();

}

function filteryear(ydb, current) {

    let max = 20;
    let years = [];

    if (ydb.includes(' ') ||
        ydb.includes('-')) {

        let ysplit = ydb.split(/-| /);

        let valid = [];
        let ongoing = false;

        if (ydb.includes('Ongoing') ||
            ydb.includes('ongoing')) {

            ongoing = true;

        }

        for (let i = 0; i < ysplit.length; i++) {

            let year = parseInt(ysplit[i]);

            if (Number.isFinite(year)) {

                valid.push(year);

            }

        }

        if (valid.length > 1 && !ongoing) {

            for (let y = valid[0]; y <= valid[1]; y++) {

                years.push(y);

            }

        } else if (valid.length === 1 && ongoing) {

            for (let y = valid[0]; y <= current; y++) {

                years.push(y);

            }

        } else if (valid.length === 0 && ongoing) {

            years.push(current);

        }


    } else {

        let valid = parseInt(ydb);

        if (valid < current + 50 && valid > current - 50) {

            years.push(valid);

        }

    }

    for (let y = 0; y < years.length; y++) {

        if (yearlist.indexOf(years[y]) === -1) {

            yearlist.push(years[y])

        }

    }

    yearlist.sort((a, b) => b - a);

    if (yearlist.length > max) {

        yearlist.length = max;

    }

    return years;

}


function filterrelated() {

    let mapc = cloneDeep(map);
    let ids = cmap.children;
    let idtree = [];

    //    BUILD TREE OF LINKED CONTENT

    function contains(target, pattern) {
        var value = 0;
        pattern.forEach(function (word) {
            value = value + target.includes(word);
        });
        return (value >= 1)
    }

    let getidtree = mapc.children.filter(function f(o) {

        if (contains(o.id, ids)) {

            return true;

        }

        if (o.children) {
            return (o.children = o.children.filter(f)).length
        }
    })

    //    GET ALL IDS

    let getids = getidtree.filter(function f(o) {

        idtree.push(o.id);

        if (o.children) {
            return (o.children = o.children.filter(f)).length
        }
    })

    return idtree;

}


function canvasquery() {

    //    DENDROGRAM QUERIES

    let canvasquery = document.querySelectorAll('div.dendrogram');
    let dendrotext = document.getElementById('dendrogram-text');
    let linksquery = document.querySelectorAll('div.dendrogram-links');

    //    LANDING QUERY

    if (canvasquery.length) {

        canvastype.landing = true;
        canvastype.wrap = canvasquery[0];

        ht = document.createElement('div');
        ht.classList.add('ht');
        ht.classList.add('idle');
        dendrotext.appendChild(ht);

        svgwrap = canvasquery[0];

        width = 975;
        radius = width / 2.8;

        tree = d3.cluster().size([2 * Math.PI, radius - 100]);

        svg = draw(map);
        svgwrap.appendChild(svg);

        connections(svgwrap);

        landingui();

    }

    //    RELATED CONTENT QUERY

    if (linksquery.length) {

        canvastype.related = true;
        canvastype.wrap = linksquery[0];

        let ids = filterrelated();

        let dendrowrap = document.getElementById('dendrogram-links-wrap');

        svgwrap = linksquery[0];

        width = 975;
        radius = width / 2.8;

        tree = d3.cluster().size([2 * Math.PI, radius - 100]);

        svg = draw(map);
        svgwrap.appendChild(svg);

        connections(svgwrap);

        ht = document.createElement('div');
        ht.classList.add('ht');
        ht.classList.add('idle');
        dendrotext.appendChild(ht);

        showrelated(svgwrap, ids);

    }


}




//FIND AND BUILD 3D OBJECTS

function getobjects() {

    objectwrap = document.getElementById('object');

    if (objectwrap) {

        objvw = objectwrap.offsetWidth;
        objvh = objectwrap.offsetHeight;
        objhalfX = objvw / 2;
        objhalfY = objhalfY / 2;



        buildobject();
        animate();

    }

}

function buildobject() {

    let objurl = objectwrap.getAttribute('url').trim() + "/";
    let objfile = objectwrap.getAttribute('obj').trim();
    let mtlfile = objectwrap.getAttribute('mtl').trim();
    let texturelist = objectwrap.getAttribute('textures');
    let texturefile = texturelist.split(',');
    let orbitax = objectwrap.getAttribute('orbit').trim();
    let orbitrot = parseInt(objectwrap.getAttribute('rotation').trim());
    objzoom = parseInt(objectwrap.getAttribute('zoom').trim());

    let linfo = document.createElement('div');
    linfo.classList.add('loadinformation');
    linfo.classList.add('pitch');
    objectwrap.appendChild(linfo);

    objcontainer = document.createElement('div');
    objectwrap.appendChild(objcontainer);

    camera = new THREE.PerspectiveCamera(45, objvw / objvh, 1, 2000);

    camera.position.z = 12 + (-1 * objzoom);

    // scene

    scene = new THREE.Scene();

    var ambientLight = new THREE.AmbientLight(0xcccccc, 1);
    scene.add(ambientLight);

    var pointLight = new THREE.PointLight(0xffffff, 1);
    camera.add(pointLight);
    scene.add(camera);

    // loader mtl



    if (mtlfile) {



        var onProgress = function (xhr) {

            if (xhr.lengthComputable) {

                let itxt = 'Loading 3D Object<br>';

                var percentComplete = xhr.loaded / xhr.total * 100;

                itxt += Math.round(percentComplete, 2) + '% loaded';

                linfo.innerHTML = itxt;

            }

        };


        // model


        function onError() {}

        var manager = new THREE.LoadingManager();
        manager.addHandler(/\.dds$/i, new DDSLoader());


        new MTLLoader(manager)
            .setPath(objurl)
            .load(mtlfile, function (materials) {

                materials.preload();

                new OBJLoader(manager)
                    .setMaterials(materials)
                    .setPath(objurl)
                    .load(objfile, function (object) {

                        objectwrap.removeChild(linfo);

                        object.rotation.y = Math.PI; // rotate the model
                        scene.add(object);
                        fitCameraToObject();

                    }, onProgress, onError);

            });



    } else {




        //    OBJ loader

        function loadModel() {

            object.traverse(function (child) {

                if (child.isMesh) child.material.map = texture;

            });

            objectwrap.removeChild(linfo);

            object.position.y = -95;
            var box = new THREE.Box3().setFromObject(object);
            var center = new THREE.Vector3();
            box.getCenter(center);
            object.position.sub(center); // center the model
            object.rotation.y = Math.PI; // rotate the model
            scene.add(object);
            fitCameraToObject();

        }

        var manager = new THREE.LoadingManager(loadModel);

        manager.onProgress = function (item, loaded, total) {

            console.log(item, loaded, total);

        };

        // texture

        var textureLoader = new THREE.TextureLoader(manager);

        var texture = textureLoader.load(texturefile[0]);


        function onProgress(xhr) {

            if (xhr.lengthComputable) {

                let itxt = 'Loading 3D Object<br>';

                var percentComplete = xhr.loaded / xhr.total * 100;

                itxt += Math.round(percentComplete, 2) + '%';

                linfo.innerHTML = itxt;

            }

        }

        function onError() {}

        var loader = new OBJLoader(manager);

        loader.load(objurl + objfile, function (obj) {

            object = obj;

        }, onProgress, onError);

    }



    renderer = new THREE.WebGLRenderer(({
        alpha: true,
        autoSize: true,
        antialias: true
    }));
    renderer.setClearColor(0x000000, 0);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(objvw, objvh);
    objcontainer.appendChild(renderer.domElement);

    controls = new OrbitControls(camera, renderer.domElement);

    controls.enableDamping = true;
    controls.dampingFactor = 0.05;
    controls.screenSpacePanning = false;
    controls.enableZoom = false;
    controls.maxPolarAngle = Math.PI / 2;

    if (orbitax === "limit") {

        controls.minPolarAngle = Math.PI / 2;

    }

    if (orbitrot && orbitrot < 360) {

        controls.minAzimuthAngle = Math.PI / (-360 / orbitrot);
        controls.maxAzimuthAngle = Math.PI / (360 / orbitrot);

        if (orbitax != "limit") {

            controls.minPolarAngle = Math.PI / (360 / orbitrot * 2);

        }

    }


    window.addEventListener('resize', onWindowResize, false);

}

function fitCameraToObject() {

    var pos = scene.position;
    camera.position.set(pos.x, pos.y, 100);
    camera.lookAt(pos);
    let center = new THREE.Vector3();
    var boxFrmScene = new THREE.Box3().setFromObject(scene);
    var height = Math.max(boxFrmScene.getSize(center).y, boxFrmScene.getSize(center).x);
    var fov = camera.fov * (Math.PI / 180);
    var distance = Math.abs(height / Math.sin(fov / 2));
    let camz = distance + (height / 2) * 0.01 + (-1 * objzoom);
    camera.position.set(pos.x, pos.y, camz);
    camera.updateProjectionMatrix();

}

function onWindowResize() {

    objvw = objectwrap.offsetWidth;
    objvh = objectwrap.offsetHeight;

    camera.aspect = objvw / objvh;
    fitCameraToObject();

    renderer.setSize(objvw, objvh);

}


function animate() {

    requestAnimationFrame(animate);
    render();

}

function render() {

    renderer.render(scene, camera);

}




//FIND AND BUILD MEDIA

function getmedia() {

    //    IMAGE MEDIA

    let imgslides = document.getElementsByClassName('img-gallery');

    if (imgslides.length) {

        buildgallery(imgslides);

    }

}

function buildgallery(slides) {

    let galleries = [];

    for (let s = 0; s < slides.length; s++) {

        galleries[s] = new Flickity(slides[s], {
            accessibility: true,
            autoPlay: false,
            cellAlign: 'center',
            draggable: '>2',
            lazyLoad: 2,
            wrapAround: true,
            prevNextButtons: false
        })

        let vn = slides[s].getElementsByTagName('video').length;

        if (vn > 0) {

            galleries[s].on('change', function (index) {

                let vi = slides[s].getElementsByTagName('video');

                for (let i = 0; i < vi.length; i++) {

                    vi[i].pause();

                }

            });

        }


    }

}


function preparedraw() {

    svgwrap.removeChild(svg);

}


function draw(mapfilter) {

    const root = tree(d3.hierarchy(mapfilter)
        .sort((a, b) => d3.ascending(a.data.name, b.data.name)));

    const svg = d3.create("svg");

    svg.append("g")
        .attr("fill", "none")
        .attr("stroke", "gray")
        .attr("stroke-opacity", 1)
        .attr("stroke-width", 1.5)
        .attr("id", "dendro-g-strokes")
        .selectAll("path")
        .data(root.links())
        .join("path")
        .attr("d", d3.linkRadial()
            .angle(d => d.x)
            .radius(d => d.y))
        .attr("source", d => d.source.data.id)
        .attr("target", d => d.target.data.id)
        .attr("color", d => d.target.data.color)
        .attr("class", "connection")
        .attr("vector-effect", "non-scaling-stroke")
        .attr("id", function (d, i) {
            return "connection" + i;
        });

    svg.append("g")
        .attr("id", "dendro-g-circles")
        .selectAll("circle")
        .data(root.descendants())
        .join("circle")
        .attr("stroke", "white")
        .attr("stroke-opacity", 1)
        .attr("stroke-width", 2)
        .attr("transform", d => `
            rotate(${d.x * 180 / Math.PI - 90})
            translate(${d.y},0)
          `)
        .attr("fill", d => d.children ? "black" : "black")
        .attr("r", 7)
        .attr("title", d => d.data.title)
        .attr("id", d => d.data.id)
        .attr("type", d => d.data.type)
        .attr("url", d => d.data.url)
        .attr("root", d => d.data.root)
        .attr("color", d => d.data.color)
        .attr("x", d => d.x)
        .attr("y", d => d.y);

    return svg.attr("viewBox", autoBox).node();

}

function autoBox() {
    document.body.appendChild(this);
    const {
        x,
        y,
        width,
        height
    } = this.getBBox();
    document.body.removeChild(this);
    return [x, y, width, height];
}


function getellipse(t, beta, correction) {

    let c = {};

    c.y = -t * Math.cos(beta) * svgvw;
    c.x = svgratio * correction * t * Math.sin(beta) * svgvw;

    return c;

}

function resizeellipse() {

    if (typeof dots !== 'undefined') {

        //        DOTS RESIZE

        let dd = svgr * (Math.PI / 180);

        for (let d = 0; d < dots.el.length; d++) {

            let dr = dots.coord[d].x + dd;

            let dn = getellipse(dots.coord[d].y, dr, gr);

            dots.el[d].setAttribute("transform", `rotate(0) translate(${dn.x},${dn.y})`);
            dots.el[d].setAttribute("r", remdots + "%");

        }

        //        LINES RESIZE

        let lines = document.getElementById('dendro-g-strokes');
        lines.setAttribute("transform", "scale(" + svgratio * gr * svgvw + " " + svgvw + ") rotate(" + svgr + ")");


    }

}

function animateellipse() {

    svgframe = requestAnimationFrame(animateellipse);
    rotateellipse();

}

function rotateellipse() {

    if (svgfps >= 3) {

        let svgclick = performance.now();
        let f = (svgclick - svgtime) / 1000;
        let svgf = 360 / (1500 / f);

        svgr += svgf;

        let dd = svgr * (Math.PI / 180);

        let lines = document.getElementById('dendro-g-strokes');
        lines.setAttribute("transform", "scale(" + svgratio * gr * svgvw + " " + svgvw + ") rotate(" + svgr + ")");

        for (let d = 0; d < dots.el.length; d++) {

            let dr = dots.coord[d].x + dd;

            let dn = getellipse(dots.coord[d].y, dr, gr);

            dots.el[d].setAttribute("transform", `rotate(0) translate(${dn.x},${dn.y})`);

        }

        svgfps = 0;

        svgtime = performance.now();

    } else {

        svgfps++;

    }


}

function connections(svgwrap) {

    //    DOTS

    dots = {};
    dots.coord = [];

    dots.el = svgwrap.querySelectorAll('circle');
    dots.el[0].classList.add('centerdot');

    rootdots = [];

    //    IMPERFECT CIRCLE CORRECTION

    let gdots = document.getElementById('dendro-g-circles');

    let gb = gdots.getBoundingClientRect();
    gr = gb.height / gb.width;

    for (let d = 0; d < dots.el.length; d++) {

        if ((canvastype.related && !istouch) || canvastype.landing) {

            dots.coord[d] = {};

            dots.coord[d].x = parseFloat(dots.el[d].getAttribute('x'));
            dots.coord[d].y = parseFloat(dots.el[d].getAttribute('y'));

            let dn = getellipse(dots.coord[d].y, dots.coord[d].x, gr);

            dots.el[d].setAttribute("transform", `rotate(0) translate(${dn.x},${dn.y})`);

        }

        let link = dots.el[d].getAttribute('url');
        let root = dots.el[d].getAttribute('root');
        let dottype = dots.el[d].getAttribute('type');

        let color = dots.el[d].getAttribute('color');
        dots.el[d].classList.add("dot" + color);

        if (link && dottype === "article") {

            dots.el[d].classList.add("hyper");

            if (istouch) {

                touchdots.push(dots.el[d]);

            }

            //            if (dots.el.length < 20) {
            //
            //                dots.el[d].classList.add('dotfocus' + color)
            //
            //            }

        }


        dots.el[d].dot = dots.el[d];

        if (root) {

            rootdots.push(dots.el[d]);

        }

        if (canvastype.landing) {

            dots.el[d].addEventListener("mouseover", drawtitle);

        }


    }

    //    TRIGGER RESIZE FOR CORRECT DOT SIZES

    resize();


    //    ANIMATE DOTS

    if (canvastype.landing) {

        let cs = 0;

        (function circlefade(i) {
            setTimeout(function () {

                dots.el[cs].classList.add('start');
                cs++;

                if (--i) circlefade(i);
                i > 0
            }, 18)
        })(dots.el.length);

    }



    //    LINES

    if ((canvastype.related && !istouch) || canvastype.landing) {

        let lines = document.getElementById('dendro-g-strokes');
        lines.setAttribute("transform", "scale(" + svgratio * gr + " 1)");

    }

    if (canvastype.landing) {

        d3.selectAll(".connection").style("opacity", "0.5");


        //Select All of the lines and process them one by one
        d3.selectAll(".connection").each(function (d, i) {

            // Get the length of each line in turn
            var totalLength = d3.select("#connection" + i).node().getTotalLength() * svgratio * 2;

            d3.selectAll("#connection" + i)
                .attr("stroke-dasharray", totalLength + " " + svgratio * totalLength)
                .attr("stroke-dashoffset", totalLength)
                .style("stroke-width", 2)
                .transition()
                .duration(500)
                .delay(18 * i)
                .attr("stroke-dashoffset", 0)
                .style("opacity", 0.7)

        })


        let dendrocenter = document.getElementById('dendrocenter');
        let islanding = (dendrocenter.getAttribute('landing') === 'true');

        if (islanding) {

            cancelAnimationFrame(svgframe);
            svgtime = performance.now();

            svgr = 0;
            svgfps = false;
            // animateellipse();

        }

    }

}

function updatecenter(smooth) {

    let cl = document.querySelector('.centerdot');
    let cy = cl.getBoundingClientRect().top;

    let wrap = document.getElementById('landing-wrap');
    let sy = wrap.scrollTop;

    let dendrocenter = document.getElementById('dendrocenter');

    if (smooth) {

        dendrocenter.classList.add('relocate');

    }

    dendrocenter.classList.add('relocated');
    dendrocenter.style.top = cy + sy + "px";

    setTimeout(function () {

        dendrocenter.classList.remove('relocate');

    }, 800);


}


function drawtitle(evt) {

    let dot = evt.currentTarget.dot;
    dot.addEventListener("mouseleave", removetitle);

    dot.url = dot.getAttribute('url');
    dot.type = dot.getAttribute('type');
    dot.title = dot.getAttribute('title');
    dot.color = dot.getAttribute('color');
    dot.id = dot.getAttribute('id');

    ht.innerHTML = dot.getAttribute('title');

    ht.classList.remove('flip');
    ht.classList.remove('idle');

    let htx = ht.getBoundingClientRect();

    if (htx.x + htx.width > 0.95 * vw) {

        ht.classList.add('flip');

    }

    if (dot.type === "article") {

        ht.classList.add('text' + dot.color);

    }

    if (canvastype.landing) {

        dot.addEventListener("click", clicktitle);
        document.body.addEventListener('mousemove', tracktitle);

    } else if (canvastype.related) {

        document.body.addEventListener('mousemove', trackrelated);

    }


}

function tracktitle(evt) {

    let px = evt.clientX;
    let py = evt.clientY;

    ht.style.left = px - dmx + "px";
    ht.style.top = py + "px";

}

function filter(arr, term) {
    let matches = [];
    if (!Array.isArray(arr)) return matches;

    arr.forEach(function (i) {
        if (i.id.includes(term)) {
            matches.push(i);
        } else {
            let childResults = filter(i.children, term);
            if (childResults.length) {

                matches = childResults.slice(0);

            }
        }
    })

    return matches;
}


function clicktitle(evt) {

    let dot = evt.currentTarget;
    let link = dot.url;
    let dottype = dot.type;

    if (link && dottype === "article") {

        window.location.href = link;

    } else if (dottype === "category") {

        //        FILTER ARRAY AND DRAW

        let mapc = cloneDeep(map);
        mapc = mapc.children.slice(0);

        let mapfilter = filter(mapc, dot.id);

        if (mapfilter[0].children.length) {

            let mapres = {};
            mapres.name = dot.id;
            mapres.type = "category";
            mapres.id = dot.id;
            mapres.children = mapfilter[0].children;

            svgwrap.removeChild(svg);
            svg = draw(mapres);
            svgwrap.appendChild(svg);

            connections(svgwrap);
            removetitle();

            //            ADD FILTER

            if (document.body.classList.contains('filter')) {

                initfilter();

            }

            //            TOGGLE HEAD

            let head = document.querySelector('.head-landing-inactive');

            if (head) {

                head.classList.add('head-landing-active');
                head.removeEventListener('click', returnfilter);
                head.addEventListener('click', returnfilter);

            }

            //            UPDATE CENTER AND RETURN TO DEFAULT

            let dendrocenter = document.getElementById('dendrocenter');

            updatecenter(true);

            let centerzoom = dendrocenter.querySelector('.center-zoom-title');

            centerzoom.classList.add('text' + mapfilter[0].color);
            centerzoom.innerHTML = mapfilter[0].title;


            dendrocenter.addEventListener('click', returnfilter);



        }

    }

}

function returnfilter() {

    svgwrap.removeChild(svg);
    svg = draw(map);
    svgwrap.appendChild(svg);

    connections(svgwrap);

    //            ADD FILTER

    if (document.body.classList.contains('filter')) {

        initfilter();

    }

    let dendrocenter = document.getElementById('dendrocenter');
    dendrocenter.removeEventListener('click', returnfilter, false);

    dendrocenter.classList.add('relocate');
    dendrocenter.classList.remove('relocated');
    dendrocenter.setAttribute('style', null);

    let centerzoom = dendrocenter.querySelector('.center-zoom-title');
    centerzoom.classList.remove('textred', 'textgreen', 'textblue');
    centerzoom.innerHTML = '';

    //    HIDE LANDING HEAD

    let head = document.querySelector('.head-landing-inactive');

    if (head) {

        head.classList.remove('head-landing-active');

    }

    setTimeout(function () {

        dendrocenter.classList.remove('relocate');

    }, 800);


}

function removetitle(evt) {

    if (canvastype.landing) {

        document.body.removeEventListener('mousemove', tracktitle, false);

    } else if (canvastype.related) {

        document.body.removeEventListener('mousemove', trackrelated, false);

    }

    ht.classList.remove('textred');
    ht.classList.remove('textblue');
    ht.classList.remove('textgreen');

    ht.classList.add('idle');
    ht.innerHTML = '';

}

function showrelated(wrap, ids) {

    let textwrap = document.getElementById('dendrogram-text');

    for (let r = 0; r < ids.length; r++) {

        let dot = wrap.querySelector('circle[id="' + ids[r] + '"]');

        if (dot) {

            let type = dot.getAttribute('type');
            dot.classList.add('related');

            if (type === 'article') {

                drawrelated(dot, textwrap, type);

            } else {

                dot.addEventListener("mouseover", drawtitle);

            }


        }

    }

}

function drawrelated(dot, wrap) {

    let ar = document.createElement('a');
    let url = dot.getAttribute('url');
    ar.setAttribute('href', url);

    let rt = document.createElement('div');
    rt.classList.add('rt');

    dot.url = dot.getAttribute('url');
    dot.type = dot.getAttribute('type');
    dot.title = dot.getAttribute('title');
    dot.color = dot.getAttribute('color');
    dot.id = dot.getAttribute('id');

    rt.innerHTML = dot.getAttribute('title');

    let dx = dot.getBoundingClientRect();
    let wx = wrap.getBoundingClientRect();

    let rx = (dx.left - wx.left + dx.width) / wx.width * 100;
    let ry = (dx.top - wx.top + dx.height) / wx.height * 100;

    rt.style.left = rx + "%";
    rt.style.top = ry + "%";

    wrap.appendChild(rt);

    let rtx = rt.getBoundingClientRect();

    if (rtx.x + rtx.width > 1.05 * wx.width) {

        rt.classList.add('flip');

    }

    rt.classList.add('text' + dot.color);

    ar.appendChild(rt);
    wrap.appendChild(ar);

    dot.addEventListener('click', function () {

        window.location.href = url;

    })

}

function trackrelated(evt) {

    let px = evt.clientX;
    let py = evt.clientY;

    let dx = canvastype.wrap.getBoundingClientRect().top;

    ht.style.left = px - dmx + "px";
    ht.style.top = py - dx + "px";

}
